import React, { useState } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import WebDev from "../../assets/images/services/web-development.png";
import WebMgmt from "../../assets/images/services/web-mgmt.png";
import WebCust from "../../assets/images/services/web-customize.png";
import Graphic from "../../assets/images/services/graphics.png";
import DataAnalytics from "../../assets/images/services/data-analytics.png";
import Intregration from "../../assets/images/services/api-intregate.png";
// import bg4 from "../../assets/images/img/bg-4.webp";
import "../../styles/module/services.css";

const servicesData = [
  {
    id: 0,
    link: "/services/web-mobile-app",
    icon: WebDev,
    tabTitle: "Web & Mobile App Development",
    cardTitle: "Web & Mobile Application Development",
    description:
      "Empower your digital journey with expertly built websites and mobile apps—designed to captivate, built to perform, and optimized to grow with your business.",
    features: [
      "Tailored UI/UX Design",
      "Cross-Platform Compatibility",
      "Progressive Web Apps (PWAs)",
      "Optimized Performance",
      "Advanced Interactive Features"
    ]
  },
  {
    id: 1,
    link: "/services/website-management",
    icon: WebMgmt,
    tabTitle: "Website Management",
    cardTitle: "Website Management & Maintenance",
    description:
      "From updates and security to performance monitoring, we manage every aspect of your website’s upkeep—ensuring it stays fast, secure, and fully functional while you focus on your business.",
    features: [
      "Regular Content Updates",
      "Comprehensive Security Checks",
      "Real-Time Performance Monitoring",
      "Automated Backup Solutions"
    ]
  },
  {
    id: 2,
    link: "/services/website-customization",
    icon: WebCust,
    tabTitle: "Website Customization",
    cardTitle: "Website Customization & Enhancements",
    description:
      "We transform your website into a strategic asset by customizing its design, features, and performance to match your brand identity and business vision.",
    features: [
      "UI/UX Improvements",
      "Plugin Configuration",
      "Seamless API Integration",
      "Custom Feature Enhancements"
    ]
  },
  {
    id: 3,
    link: "/services/desing-branding",
    icon: Graphic,
    tabTitle: "Graphic Design & Branding",
    cardTitle: "Graphic Design & Brand Identity",
    description:
      "We develop polished, cohesive brand identities that communicate professionalism and purpose. From logo design to full visual systems, every element is crafted to reflect your brand’s unique value and vision.",
    features: [
      "Logo Design & Brand Identity",
      "Visual Branding & Standardization",
      "Key Visuals & Style Guides",
      "Marketing & Promotional Graphics"
    ]
  },
  {
    id: 4,
    link: "/services/analytics-insights",
    icon: DataAnalytics,
    tabTitle: "Data Analytics & Insights",
    cardTitle: "Data Analytics & Business Insights",
    description:
      "We turn complex data into meaningful insights. From user behavior to business performance, our analytics solutions empower you to make smarter, faster, and data-driven decisions.",
    features: [
      "Interactive Data Visualization",
      "Accurate Data Cleaning & Preparation",
      "Efficient Query Optimization",
      "Actionable Insight Generation",
      "Comprehensive Business Reporting"
    ]
  },
  {
    id: 5,
    link: "/services/api-integration",
    icon: Intregration,
    tabTitle: "API & System Integration",
    cardTitle: "API & System Integration",
    description:
      "We streamline your operations by securely integrating APIs, platforms, and services. From payment gateways to CRMs and third-party tools, we ensure your systems work together flawlessly for maximum efficiency.",
    features: [
      "RESTful API Development",
      "Secure Payment Gateway Integration",
      "OAuth Authentication",
      "Webhook Configuration",
      "Third-Party Service Integration"
    ]
  }
];

export default function Services() {
  useScrollReveal("slide-from-bottom");
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");

  const [activeTab, setActiveTab] = useState(0);
  const currentService = servicesData[activeTab];

  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const isHomePage = pathname === "/" || pathname === "" || pathname === "/home";

  const handlePointClick = (serviceLink) => {
    if (isHomePage) {
      window.location.href = "/services";
    } else {
      window.location.href = serviceLink;
    }
  };

  return (
    <section className="section section__services" style={{ position: "relative" }}>
      {/* <img
        src={bg4}
        alt="container background"
        className="container-bg image-background left slide-from-left"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "1180px",
          height: "100%",
          objectFit: "cover",
          objectPosition: "top left",
          pointerEvents: "none",
          zIndex: -1,
        }}
      /> */}

      <div className="container ros">
        <h5 className="drop-from-top">Our Services</h5>
        <h2 className="drop-from-top" style={{ marginBottom: 40 }}>
          Overview of our services
        </h2>

        {/* Overview Interactive Layout (Tabs + Active Service Card) */}
        <div className="services-overview-wrapper slide-from-bottom">
          {/* Left Column: Category Navigation Tabs */}
          <div className="services-tabs-list">
            {servicesData.map((service, index) => {
              const isActive = index === activeTab;
              return (
                <div
                  key={service.id}
                  className={`service-tab-item ${isActive ? "active" : ""}`}
                  onClick={() => setActiveTab(index)}
                >
                  <span className="tab-active-indicator"></span>
                  <div className="service-tab-icon-wrap">
                    <img
                      src={service.icon}
                      alt={service.tabTitle}
                      className="service-tab-icon"
                    />
                  </div>
                  <span className="service-tab-title">{service.tabTitle}</span>
                </div>
              );
            })}
          </div>

          {/* Right Column: Active Service Details Card */}
          <div className="service-details-card" key={activeTab}>
            <div className="service-card-header">
              <div className="service-category-badge">
                <span className="badge-pulse"></span>
                <span className="badge-text">Service 0{activeTab + 1} / 06</span>
              </div>
              <h3 className="service-card-title">{currentService.cardTitle}</h3>
              {isHomePage && (
                <p className="service-card-desc">{currentService.description}</p>
              )}
            </div>

            <div className="service-card-body-grid">
              {/* Features Bullet List matching reference image styling (Red Dots + Dividers + Right Chevron Arrow) */}
              <div className="service-features-list">
                {currentService.features.map((feature, idx) => (
                  <div
                    key={idx}
                    className="service-feature-item"
                    onClick={() => handlePointClick(currentService.link)}
                  >
                    <div className="feature-left">
                      <span className="feature-dot"></span>
                      <span className="feature-text">{feature}</span>
                    </div>
                    <div className="feature-arrow-badge">
                      <svg
                        className="feature-arrow"
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
